import React from "react";
import { Link } from "react-router-dom";
import Menu from "../components/Menu";
import "../styles/nopage.css";

const NoPage = () => {
  return (
    <div className="nopage">
      <Menu />
      <div className="nopage-content">
        <div className="nopage-container">
          <h1>404</h1>
          <h2>Page Not Found</h2>
          <p>The page you're looking for doesn't exist.</p>
          <Link to="/" className="btn btn-primary">
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NoPage;

